import { useParams } from '@tanstack/react-router';
import { TransitDetail } from '@/features/transits/transit-detail';
import { AppLayout } from '@/layouts/app-layout';

export function TransitDetailPage() {
  const { id } = useParams({ from: '/transits/$id' });

  return (
    <AppLayout>
      <TransitDetail id={id} />
    </AppLayout>
  );
}
